<template>
    <div class="headControll">
        <div class="head">
            <div class="logo">2020版造价计价标准宣贯学习</div>
            <div class="navControll">
                <div class="nav" @click="logout"><router-link to="/" class="router-link-active">退出登录</router-link></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Head.vue',
    methods: {
        logout() {
            this.$store.dispatch('del_enter');
            this.$router.push('/');
        }
    }
};
</script>

<style lang="less" scoped>
.headControll {
    width: 100%;
    background: #467cf8;
    height: 80px;
    .head {
        height: 80px;
        width: 1110px;
        display: flex;
        margin: auto;
        justify-content: space-between;
        align-items: center;
        .logo {
            text-align: left;
            font-size: 16px;
            color: #fff;
        }
        .navControll {
            display: flex;
            align-items: center;
            .nav {
                color: #fff !important;
                font-size: 16px;
                display: inline;
                margin-left: 20px;
                transition: all 0.3s;
                cursor: pointer;
                &:first-child {
                    margin-left: unset;
                }
                &:hover {
                    color: #000 !important;
                }
            }
        }
    }
}
a {
    text-decoraction: none !important;
}
.router-link-active {
    text-decoration: none !important;
    color: #333;
    transition: all 0.3s;
    &:hover {
        color: #fff;
    }
}
</style>
